/**
 * @ngdoc Directive
 * @nae vrmWhatsnewChangelogWidget
 * @example
 *
 * <vrmWhatsnewChangelogWidget  />
 *
 */


(function () {
    'use strict';

    angular.module('vrm.components')
        .directive('vrmWhatsnewChangelogWidget', vrmWhatsnewChangelogWidget);


    /* @ngInject */
    function vrmWhatsnewChangelogWidget($state, $rootScope, ApiService, VrmModalService, vrmConfig, $interval, localStorageService) {

        return {
            scope: {
                changelogGroups: '='
            },
            restrict: 'E',
            template: require('@/angular/modules/vrm-components/whatsnew-changelog-widget/whatsnew-changelog-widget.template.html'),
            controller: controller,
        };

        /* @ngInject */
        function controller($scope) {
            const key = 'latest_changelog_id';
            $scope.selectedChangelog = null;

            const outsideWhatsnewClickListener = $rootScope.$on("onOutsideWhatsnewChangelogClick", function (event, data) {
                $scope.selectedChangelog = null;
            });

            $scope.showSelectedChangelog = function (selectedChangelog) {
                var latestViewedChangelog = localStorageService.get(key);
                if (selectedChangelog.idWhatsnew > latestViewedChangelog)
                    localStorageService.set(key, selectedChangelog.idWhatsnew)
                $rootScope.$emit('viewSelectedWhatsnewChangelog', {id: selectedChangelog.idWhatsnew, createdAt: selectedChangelog.createdAt});
                $scope.selectedChangelog = selectedChangelog;
            }

            $scope.emitCloseChangelogPopupEvent = function () {
                $rootScope.$emit("closeChangelogPopupEvent");
            }

            var scrollable_div = angular.element(document.querySelector('.vrm-whatsnew-changelog__preview__item'));

            $scope.goBackToChangelog = function () {
                $scope.selectedChangelog = null;
            };

            scrollable_div.bind('scroll', function (e) {
                if (e.currentTarget.scrollHeight - e.currentTarget.offsetHeight <= e.currentTarget.scrollTop + 30) {
                    angular.element(document.querySelector('.vrm-whatsnew-changelog__popup__preview')).addClass("vrm-whatsnew-changelog__text__fadeout-inactive");
                } else {
                    angular.element(document.querySelector('.vrm-whatsnew-changelog__popup__preview')).removeClass("vrm-whatsnew-changelog__text__fadeout-inactive");
                }
            });

            $scope.$on('$destroy', () => {
                outsideWhatsnewClickListener();
            })
        }
    }
})();
